var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelshFireSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.6 136.1",
    style: {
      enableBackground: "new 0 0 146.6 136.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .wf-st0{fill:#FFFFFF;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wf-st0",
    d: "M55.6,54.2h25.1V25.1h34.5l29.6-25l-59.4,0L55.6,25.1C55.6,25.1,55.6,54.2,55.6,54.2z M121.6,46.5v67.5 l25.1-21.1V25.3L121.6,46.5L121.6,46.5z M32.4,103.1c-5.9-8-7.4-20.3-7.4-29V0L0,21.1v54.1c0,45.6,30.3,58.4,39.6,60.9l26.3-22.1 C51.9,116.3,40.1,113.4,32.4,103.1L32.4,103.1z M88.1,103.1c-4.5-6.1-6.4-14.7-7.1-22.4l31.5-26.5H80.7L55.6,75.3 c0,9.2,1.3,17.1,3.3,23.9c8.1,26.4,28.9,34.9,36.3,36.9l26.3-22.1C107.5,116.3,95.7,113.4,88.1,103.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelshFireSymbol);
export default __webpack_public_path__ + "static/media/welsh-fire-symbol.4aae3860.svg";
export { ForwardRef as ReactComponent };